<template>
  <div>
    <Header :fixed="true" :models="models" />
    <div class="usp-main">
      <!-- 第一屏 -->
      <template>
        <div v-for="item in currentPlatformData.module1" :key="item.id">
          <ani-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></ani-screen>
        </div>
      </template>
      <!-- 第二屏 视频-->
      <template>
        <div v-for="item in currentPlatformData.module2" :key="item.id">
          <video-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></video-screen>
        </div>
      </template>

      <!-- 第三屏 大图+轮播-->
      <template>
        <div v-for="item in currentPlatformData.module3" :key="item.id">
          <xiao-can
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></xiao-can>
        </div>
      </template>

      <!-- 第四屏 轮播-->
      <template>
        <div v-for="item in currentPlatformData.module4" :key="item.id">
          <gif-player
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></gif-player>
        </div>
      </template>

      <!-- 第四屏 不需要动画（车内放大效果去掉）-->
      <template>
        <div v-for="item in currentPlatformData.module5" :key="item.id">
          <stack-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
            :device="device"
          ></stack-screen>
        </div>
      </template>
      <template>
        <div v-for="item in currentPlatformData.module6" :key="item.id">
          <horizontalScreen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
            :device="device"
          ></horizontalScreen>
        </div>
      </template>
      <template>
        <div v-for="item in currentPlatformData.module7" :key="item.id">
          <swiper-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></swiper-screen>
        </div>
      </template>
      <!-- 第五屏 不需要动画（车的滚动去掉）-->

      <!-- 第六屏 不需要动画（滚动切换下一张的图片的动画不要）-->

      <!-- 第七屏 不需要动画（滚动切换下一张的图片的动画不要）-->
      <!-- 第八屏 （地图gif）-->
      <template>
        <div v-for="item in currentPlatformData.module8" :key="item.id">
          <map-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></map-screen>
        </div>
      </template>

      <!-- 第九屏 左右两个视频 -->
      <template
        v-if="currentPlatformData.module9 && currentPlatformData.module9.length"
      >
        <div v-for="item in currentPlatformData.module9" :key="item.id">
          <more-video-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></more-video-screen>
        </div>
      </template>
      <!-- <div class="usp-app-video-player bg-g">
        <div class="usp-app-video-player-item" v-for="(item, index) in videos" :key="index">
          <div class="usp-app-video-player-item-video">
            <div
              class="usp-app-video-player-item-video-mask"
              @click="playVideo(index)"
              :class="{ hide: item.isPlay }"
            >
              <div class="play-btn"></div>
            </div>
            <div
              class="usp-app-video-player-item-video-poster"
              :class="{ hide: item.isPlayed }"
              :style="'background-image:url(' + item.poster + ');'"
            ></div>
            <video
              preload
              muted="muted"
              :class="{ hide: item.isPlay }"
              class="usp-video usp-app-video-player-item-video-img"
              webkit-playsinline
              playsinline
              loop="loop"
            >
              <source :src="item.video" type="video/mp4" />
            </video>
          </div>
          <div class="usp-app-video-player-item-data">
            <div class="usp-app-video-player-item-data-title">{{ item.title }}</div>
            <div class="usp-app-video-player-item-data-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>-->
      <!-- 第十屏 九宫格 -->
      <template>
        <div v-for="item in currentPlatformData.module10" :key="item.id">
          <squared-images
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></squared-images>
        </div>
      </template>
      <!-- <template>
        <newani></newani>
      </template>-->
      <!-- 第十一屏 底部 -->
      <template>
        <div v-for="item in currentPlatformData.module11" :key="item.id">
          <footer-screen
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></footer-screen>
        </div>
      </template>
      <!-- 第十二屏 文件下载入口 -->
      <template>
        <div v-for="item in currentPlatformData.module12" :key="item.id">
          <file-download
            :moduleData="item"
            v-if="item.show === 'YES' || item.show === 'true'"
          ></file-download>
        </div>
      </template>
    </div>
    <div class="hr"></div>
    <Floor />
  </div>
</template>

<script>
import { getOfficialWebsiteCarPageDetailList } from "@api/siteConfig";
import allData from "./data";
import { getDevice } from "@utils/device";
import Header from "@components/HeaderEn/index.vue";
import Floor from "@components/FloorEn/index.vue";
import aniScreen from "./aniScreen.vue"; //第一屏
import videoScreen from "./videoScreen.vue"; //视频屏
import xiaoCan from "./xiaocan.vue"; //第二屏
import gifPlayer from "./gifPlayer.vue"; //第二屏moreVideoScreen
import stackScreen from "./stackScreen.vue";
import moreVideoScreen from "./moreVideoScreen.vue"; //左右两个视频
import horizontalScreen from "./horizontalScreen.vue"; //第六屏
import swiperScreen from "./swiperScreen.vue";
import squaredImages from "./squaredImages.vue";
import mapScreen from "./mapScreen.vue";
import footerScreen from "./footerScreen.vue";
import fileDownload from "./fileDownload.vue";
// import newani  from './newani.vue'

export default {
  name: "usp-007",
  components: {
    Header,
    Floor,
    aniScreen,
    videoScreen,
    xiaoCan,
    gifPlayer,
    stackScreen,
    moreVideoScreen,
    // eslint-disable-next-line vue/no-unused-components
    horizontalScreen,
    swiperScreen,
    // eslint-disable-next-line vue/no-unused-components
    squaredImages,
    mapScreen,
    footerScreen,
    fileDownload,
    // newani
  },
  data() {
    this.lockVideo = false;
    this.updateAni = null;
    return {
      videoIndex: 0,
      // allData:[],//所有的数据（包括三端）
      currentPlatformData: {}, //当前设备的数据（只有一端）
      allData,
      models: "",

      // pageId对应的usp枚举
      devDict: {
        107: "v09",
        108: "a06",
        110: "a06plus",
      },
      prdDict: {
        3: "v09",
        4: "a06",
        6: "a06plus",
      },
    };
  },
  async mounted() {
    this.device = getDevice();
    const url = window.location.href;
    const dz_url = url.split("?")[1];
    const pageId = dz_url.split("=")[1];
    await getOfficialWebsiteCarPageDetailList({ pageId }).then((res) => {
      console.log("getOfficialWebsiteCarPageDetailList", res);
      document.title = `HYCAN | ${res.data.pageName}`;
      this.allData = res.data;
    });

    const env = process.env.NODE_ENV;
    console.log("env:" + env);
    switch (env) {
      case "development":
        this.models = this.devDict[pageId];
        break;
      case "production":
        this.models = this.prdDict[pageId];
        break;
    }

    console.log(this.models);

    // console.log("data",allData.platformVos)
    const currentPlatformData = this.allData.platformVos.filter((item) => {
      return item.platform === this.device;
    });
    console.log("currentPlatformDatacurrentPlatformData", currentPlatformData);

    this.currentPlatformData = Object.assign(currentPlatformData[0]);
    console.log(this.currentPlatformData);
    // let obj = {}
    // allData.platformVos.map(item => {
    // })
  },
  unMounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
@import "../../assets/font/helveticaneue/index.css";
html,
body {
  font-family: "SF Pro", "SF Pro Text", "pingFang SC", "Microsoft YaHei",
    "Heiti SC", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.usp-banner {
  width: 100%;
  // height: 100vh;
}
.usp-main {
  img {
    pointer-events: none;
  }
  @include setThemeClass {
    .bg-w {
      background-color: getThemeVal(brandColorWhite);
    }
    .bg-g {
      background-color: getThemeVal(backgroundColorGray);
    }
  }

  @include setThemeClass {
    .usp-gif-player-box {
      padding: vw(100) 0 vw(100);
      @include media(
        (
          $home-md: (
            padding: 60px 0,
          ),
          $home-sm: (
            padding: 40px 0,
          ),
        )
      );
      .usp-gif-player {
        position: relative;
        margin: 0 vw(294);
        padding: 0 90px;
        box-sizing: content-box;
        @include media(
          (
            $home-md: (
              margin: 0,
              padding: 0 80px,
            ),
            $home-sm: (
              margin: 0,
              padding: 0,
            ),
          )
        );
        .gif-swiper {
          overflow: hidden;
          margin-right: vw(-1);
          margin-bottom: vw(-1);
          .gif-swiper-image {
            box-sizing: content-box;
            width: 100%;
            height: 100%;
            object-fit: cover;
            video {
              display: block;
            }
          }
        }
        .gif-swiper-prev {
          left: 0;
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164314543-icon_common_arrows_24_lef_white@3x.png",
            24px 24px,
            13px center
          );
        }
        .gif-swiper-next {
          right: 0;
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164317608-icon_common_arrows_24_rig_white@3x.png",
            24px 24px,
            4px center
          );
        }
        .gif-swiper-next,
        .gif-swiper-prev {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background-color: getThemeVal(brandColorBlackOpacity4);
          cursor: pointer;
          transition: all 0.26s $easeOutCubic;
          @include media(
            (
              $home-sm: (
                display: none,
              ),
            )
          );
        }
        .gif-swiper-next:hover,
        .gif-swiper-prev:hover {
          background-color: getThemeVal(brandColorBlackOpacity);
        }
      }
      .gif-swiper-dots {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .gif-swiper-dot {
          width: 100px;
          height: 2px;
          background-color: getThemeVal(lineColor);
          transition: all 0.26s $easeOutCubic;
          &.active {
            background-color: getThemeVal(brandColor);
          }
        }
        .gif-swiper-dot + .gif-swiper-dot {
          margin-left: 10px;
        }
      }
      .gif-swiper-title,
      .gif-swiper-desc {
        padding: 0 20px;
        text-align: center;
      }
      .gif-swiper-title {
        margin-top: 30px;
        @include media(
          (
            $home-md: (
              font-size: 28px,
              line-height: 42px,
              margin-top: 20px,
            ),
          )
        );
      }
      .gif-swiper-desc {
        margin-top: 10px;
        @include media(
          (
            $home-md: (
              margin-top: 20px,
              font-size: 14px,
              line-height: 22px,
            ),
          )
        );
      }
    }
  }
  @include setThemeClass {
    .usp-app-ctrl {
      position: relative;
      overflow: hidden;
      @include media(
        (
          $home-sm: (
            background-color: getThemeVal(brandColorWhite),
          ),
        )
      );

      .usp-app-mask {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(
          180deg,
          getThemeVal(brandColorBlackOpacity1) 0%,
          rgba(0, 0, 0, 0) 50%
        );
        z-index: 3;
      }
      .usp-app-ctrl-car-box {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
        background: setBgImg(
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040369-web_usp_05@1x.jpg",
          cover
        );
        @include media((
            $home-md: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124144-ipad_car@3x.png),
            ),
            $home-sm: (
              background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630160124129-phone_car@3x.png),
            ),
          )
        );
        .usp-app-ctrl-car {
          position: absolute;
          top: 30%;
          left: 50%;
          margin-left: vw(-725);
          width: vw(1454);
          height: vw(818);
          background: setBgImg(
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165040551-car007@3x.png",
            contain
          );
          @include media(
            (
              $home-md: (
                margin-left: -405px,
                width: 810px,
                height: 458px,
                top: 35%,
              ),
              $home-sm: (
                margin-left: -188px,
                width: 375px,
                height: 211px,
                top: 50%,
              ),
            )
          );
          .usp-app-ctrl-car-run {
            position: absolute;
            width: vw(198);
            height: vw(198);
            background: setBgImg(
              "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210625165039906-before@3x.png",
              contain
            );
            @include media(
              (
                $home-md: (
                  width: 111px,
                  height: 111px,
                ),
                $home-sm: (
                  width: 51px,
                  height: 51px,
                ),
              )
            );
          }
          .run1 {
            top: vw(402);
            left: vw(239);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  left: 132px,
                ),
                $home-sm: (
                  top: 105px,
                  left: 62px,
                ),
              )
            );
          }
          .run2 {
            top: vw(402);
            right: vw(255);
            @include media(
              (
                $home-md: (
                  top: 227px,
                  right: 139px,
                ),
                $home-sm: (
                  top: 105px,
                  right: 65px,
                ),
              )
            );
          }
        }
      }
    }
    .usp-app-ctrl-bg-outer {
      position: relative;
    }
    .usp-app-ctrl-bg {
      .usp-app-ctrl-bg-img {
        width: 100%;
        height: auto;
      }
    }

    .usp-app-ctrl-title {
      position: relative;
      z-index: 3;
      margin-top: vw(100);
      padding: 0 20px;
      @include h1-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 60px,
            font-size: 36px,
            line-height: 48px,
          ),
          $home-sm: (
            margin-top: 40px,
            font-size: 28px,
            line-height: 42px,
          ),
        )
      );
    }
    .usp-app-ctrl-desc {
      position: relative;
      z-index: 3;
      margin-top: vw(20);
      padding: 0 20px;
      @include h3-s(getThemeVal(brandColorWhite), vw);
      @include media(
        (
          $home-md: (
            margin-top: 10px,
            font-size: 14px,
            line-height: 30px,
          ),
        )
      );
    }
    .usp-app-ctrl-top {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
    }
    .usp-app-ctrl-right {
      position: absolute;
      width: vw(900);
      right: 0;
      top: 0;
      bottom: 0;
      overflow: hidden;
      text-align: center;
      z-index: 10;
      background-color: getThemeVal(navColorBlackOpacity2);
      @include media(
        (
          $home-md: (
            width: 52%,
          ),
          $home-sm: (
            width: 100%,
            background-color: transparent,
            position: relative,
            right: auto,
            top: auto,
            bottom: auto,
            padding-bottom: 40px,
          ),
        )
      );
      .usp-app-ctrl-phone {
        margin: 0 auto;
        margin-top: vw(60);
        width: vw(440);
        height: auto;
        display: block;
        @include media(
          (
            $home-md: (
              margin: 118px auto 0,
              width: 297px,
            ),
            $home-sm: (
              margin-top: 324px,
            ),
          )
        );
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .ctrl1 {
      overflow: hidden;
      .usp-app-ctrl-bg-outer {
        @include media(
          (
            $home-sm: (
              position: absolute,
              top: 0,
              left: 0,
              right: 0,
              z-index: 1,
            ),
          )
        );
      }
    }
  }

  @include setThemeClass {
    .usp-app-hz-player-box {
      background-color: getThemeVal(brandColorWhite);
    }
  }
  .usp-app-hz-player-box {
    position: relative;
    // height: 300vh;
    .usp-app-hz-player-outer {
      // position: absolute;
      // left: 0;
      // right: 0;
      // z-index: 10;
      .usp-app-hz-player {
        position: relative;
        .usp-app-hz-player-item {
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
        .usp-app-hz-player-item:not(:last-child) {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
      .usp-app-hz-dots-outer-mb {
        display: none;
        @include media(
          (
            $home-sm: (
              display: block,
            ),
          )
        );
        .usp-app-hz-dots-mb {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          @include setThemeClass {
            .usp-app-hz-dot-mb {
              width: 100px;
              height: 2px;
              background-color: getThemeVal(lineColor);
              &.active {
                background-color: getThemeVal(brandColor);
              }
              & + .usp-app-hz-dot-mb {
                margin-left: 10px;
              }
            }
          }
        }
        .usp-app-hz-dots-outer-mb-title {
          font-size: 20px;
          font-weight: bold;
          line-height: 30px;
          margin-top: 20px;
          text-align: center;
        }
      }

      .usp-app-hz-dots-outer {
        display: flex;
        justify-content: center;
        @include media(
          (
            $home-sm: (
              display: none,
            ),
          )
        );
        .usp-app-hz-dots {
          position: relative;
          margin-top: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 12px;

          @include setThemeClass {
            .usp-app-hz-dot {
              @include h3(getThemeVal(textSubtitleColor));
              font-weight: 500;
              &.active {
                color: getThemeVal(brandColorBlack);
              }
            }
            .usp-app-hz-dot + .usp-app-hz-dot {
              margin-left: 60px;
            }
            .usp-app-hz-dot-slide-bar {
              position: absolute;
              left: 0;
              width: 100%;
              bottom: 0;
              height: 2px;
              background-color: getThemeVal(lineColor);
              .usp-app-hz-dot-slider.pos-1 {
                left: 50%;
                transform: translateX(-50%);
              }
              .usp-app-hz-dot-slider.pos-2 {
                right: 0;
                left: auto;
              }
              .usp-app-hz-dot-slider {
                position: absolute;
                top: 0;
                left: 0;
                width: 120px;
                height: 2px;
                background-color: getThemeVal(brandColorBlack);
                transition: ease-in-out 0.2s all;
                @include media(
                  (
                    $home-md: (
                      width: 84px,
                    ),
                  )
                );
              }
            }
          }
        }
      }
      @include setThemeClass {
        .usp-app-hz-desc {
          padding: 0 20px;
          margin-top: 20px;
          @include h3-s(getThemeVal(brandColorBlack));
          text-align: center;
          @include media(
            (
              $home-sm: (
                margin-top: 10px,
              ),
            )
          );
        }
      }
    }
  }
  .usp-app-hz-bottom {
    padding-bottom: 64px;
    @include media(
      (
        $home-sm: (
          padding-bottom: 40px,
        ),
      )
    );
  }
  @include setThemeClass {
    .usp-app-map {
      position: relative;
      padding-bottom: vw(100);
      background-color: getThemeVal(brandColorWhite);
      @include media(
        (
          $home-md: (
            padding-top: 60px,
            padding-bottom: 60px,
            background-color: getThemeVal(backgroundColorGray),
          ),
          $home-sm: (
            padding-top: 40px,
            padding-bottom: 40px,
          ),
        )
      );
      .usp-app-map-text {
        position: absolute;
        left: 0;
        right: 0;
        top: vw(100);
        z-index: 1;
        @include media(
          (
            $home-md: (
              position: static,
              left: auto,
              right: auto,
              top: auto,
            ),
          )
        );
        .usp-app-map-title {
          text-align: center;
          @include media(
            (
              $home-md: (
                margin-bottom: 10px,
                font-size: 36px,
                line-height: 48px,
              ),
              $home-sm: (
                font-size: 28px,
                line-height: 42px,
              ),
            )
          );
        }
        .usp-app-map-desc {
          margin-top: 10px;
          margin-bottom: 40px;
          text-align: center;
          @include media(
            (
              $home-md: (
                font-size: 14px,
                line-height: 30px,
              ),
              $home-sm: (
                margin-bottom: 30px,
              ),
            )
          );
        }
      }
      .usp-app-map-gif {
        position: relative;
        width: 100%;
        height: auto;
      }
    }
  }
  .usp-app-video-player {
    padding-top: 16px;
    padding-bottom: vw(100);
    margin: 0 -8px;
    display: flex;
    align-items: flex-start;
    @include media(
      (
        $home-md: (
          padding-top: 0,
          padding-bottom: 60px,
        ),
        $home-sm: (
          display: block,
          padding-bottom: 40px,
        ),
      )
    );
    .usp-app-video-player-item + .usp-app-video-player-item {
      @include media(
        (
          $home-sm: (
            margin-top: 40px,
          ),
        )
      );
    }
    .usp-app-video-player-item {
      padding: 0 8px;
      width: 50%;
      box-sizing: border-box;
      @include media(
        (
          $home-sm: (
            width: 100%,
            display: block,
          ),
        )
      );
      .usp-app-video-player-item-video {
        position: relative;
        overflow: hidden;
        cursor: pointer;
        @include setThemeClass {
          &:hover {
            .usp-app-video-player-item-video-mask {
              background-color: getThemeVal(brandColorBlackOpacity4);
            }
            .usp-app-video-player-item-video-poster {
              transform: scale(1.1, 1.1);
              @include media(
                (
                  $home-sm: (
                    transform: none,
                  ),
                )
              );
            }
          }
        }

        .usp-app-video-player-item-video-mask {
          opacity: 1;
          &.hide {
            opacity: 0;
          }
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          transition: background-color 0.5s $easeOutCubic,
            opacity 0.5s $easeOutCubic;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .play-btn {
            width: 50px;
            height: 50px;
            background: setBgImg(
              "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210628182137368-web_usp_vdo@2x.png",
              contain
            );
          }
        }
        .usp-app-video-player-item-video-poster {
          &.hide {
            opacity: 0;
          }
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
          background: no-repeat center center/cover;
          transition: transform 0.5s $easeOutCubic;
        }
        .usp-app-video-player-item-video-img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
          &.hide {
            transform: none;
          }
          @include media(
            (
              $home-sm: (
                height: 250px,
                display: block,
              ),
            )
          );
        }
      }
      .usp-app-video-player-item-data {
        text-align: center;
        @include setThemeClass {
          .usp-app-video-player-item-data-title {
            margin-top: vw(60);
            @include h2(getThemeVal(brandColorBlack), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 30px,
                  font-size: 28px,
                  line-height: 42px,
                ),
              )
            );
          }
          .usp-app-video-player-item-data-desc {
            margin-top: vw(20);
            @include h3-s(getThemeVal(brandColorBlack), vw);
            @include media(
              (
                $home-md: (
                  margin-top: 10px,
                  font-size: 14px,
                  line-height: 30px,
                ),
              )
            );
          }
        }
      }
    }
  }
  .usp-app-imgs {
    padding: vw(100) 0;
    @include media(
      (
        $home-md: (
          padding: 60px 0,
        ),
        $home-sm: (
          padding: 40px 0,
        ),
      )
    );
    .usp-app-imgs-title {
      padding: 0 20px;
      margin-bottom: 20px;
      text-align: center;
      @include media(
        (
          $home-md: (
            margin-bottom: 10px,
            font-size: 36px,
            line-height: 48px,
          ),
          $home-sm: (
            font-size: 28px,
            line-height: 42px,
          ),
        )
      );
    }
    .usp-app-imgs-title-desc {
      margin-bottom: vw(60);
      padding: 0 20px;
      text-align: center;
      @include media(
        (
          $home-md: (
            font-size: 14px,
            line-height: 30px,
            margin-bottom: 40px,
          ),
          $home-sm: (
            margin-bottom: 30px,
          ),
        )
      );
    }
    .usp-app-img-list {
      display: flex;
      align-items: center;
      @include media(
        (
          $home-md: (
            display: block,
          ),
        )
      );
      .usp-app-img-list-left {
        width: vw(1018);
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
          display: block;
        }
        @include media(
          (
            $home-md: (
              margin-bottom: 16px,
              width: 100%,
            ),
          )
        );
      }
      .usp-app-img-list-right {
        margin-left: vw(16);
        flex: 1;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          @include media(
            (
              $home-md: (
                height: auto,
              ),
            )
          );
        }
        @include media(
          (
            $home-md: (
              margin-top: 16px,
              margin-left: 0,
              width: 100%,
            ),
          )
        );

        .usp-app-img-list-right-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          @include media(
            (
              $home-sm: (
                display: block,
              ),
            )
          );
          & > div {
            flex: 1;
            height: vw(504);
            @include media(
              (
                $home-md: (
                  height: auto,
                ),
              )
            );
          }
        }
        .usp-app-img-list-right-bottom {
          margin-top: vw(16);
          display: flex;
          align-items: center;
          justify-content: space-between;
          @include media(
            (
              $home-md: (
                margin-top: 16px,
              ),
              $home-sm: (
                display: block,
                margin-left: 0,
                width: 100%,
              ),
            )
          );
          & > div {
            flex: 1;
            height: vw(498);
            @include media(
              (
                $home-md: (
                  height: auto,
                ),
              )
            );
          }
        }
        .usp-app-img-list-right-top,
        .usp-app-img-list-right-bottom {
          div + div {
            margin-left: vw(16);
            @include media(
              (
                $home-md: (
                  margin-left: 16px,
                  width: 100%,
                ),
                $home-sm: (
                  margin-left: 0,
                  margin-top: 16px,
                ),
              )
            );
          }
        }
      }
    }
    @include setThemeClass {
      .usp-app-img {
        @include lgButton(getThemeVal(brandColorBlack));
        margin: vw(100) auto 0;
        width: 420px;
        height: 60px;
        @include media(
          (
            $home-md: (
              margin-top: 60px,
              width: 350px,
              height: 44px,
            ),
            $home-sm: (
              margin: 40px 20px 0,
              width: auto,
            ),
          )
        );
      }
    }
    &.active {
      .ani {
        transform: translateY(0);
        opacity: 1;
      }
    }
    .ani {
      // opacity: 0;
      // transform: translateY(80px);
      transition-property: transform, opacity;
      transition-timing-function: $easeOutCubic;
      transition-duration: 260ms;
    }
    .delay-1 {
      transition-delay: 60ms;
    }
    .delay-2 {
      transition-delay: 120ms;
    }
    .delay-3 {
      transition-delay: 180ms;
    }
    .delay-4 {
      transition-delay: 240ms;
    }
    .delay-5 {
      transition-delay: 300ms;
    }
    .delay-6 {
      transition-delay: 360ms;
    }
  }
}
.inPad {
  display: none;
  @include media(
    (
      $home-md: (
        display: block,
      ),
    )
  );
}
.usp-video {
  width: 100%;
  height: 100%;
  border: 0;
  margin: 0;
  padding: 0;
  background-color: transparent;
  object-fit: cover;
}

//全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
//播放按钮
video::-webkit-media-controls-play-button {
  display: none;
}
//进度条
video::-webkit-media-controls-timeline {
  display: none;
}
//观看的当前时间
video::-webkit-media-controls-current-time-display {
  display: none;
}
//剩余时间
video::-webkit-media-controls-time-remaining-display {
  display: none;
}
//音量按钮
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
//音量的控制条
video::-webkit-media-controls-volume-slider {
  display: none;
}
//所有控件
video::-webkit-media-controls-enclosure {
  display: none;
}
</style>
